import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { useAdminAuthSlice } from '../store/slices/adminAuth';

export default function RedirectIfAdmin({ children }: { children: React.ReactNode }) {
  useAdminAuthSlice();
  const token = useAppSelector((s) => s.adminAuth?.token);
  if (token) return <Navigate to="/admin/dashboard" replace />;
  return <>{children}</>;
}
